import React, { FC } from 'react';
import { Redirect, Switch, useLocation, useRouteMatch } from 'react-router';
import { Route } from 'react-router-dom';
import ReserveReportList from '../reserve/ReserveReportList';
import { ReserveDetail } from '../reserve/ReserveDetail';
import { PageNotFound } from '../PageNotFound';
import { ReserveCheckout } from '../reserve/ReserveCheckout';
import { ManageSubscriptionsPage } from '../subscriptions/ManageSubscriptionsPage';
import { ManageRenewalsPage } from '../renewals/ManageRenewalsPage';
import { COLLECTION_NAVIGATION_V2, useFeature } from '../../shared/utils/togglz';

export const AssistantPage: FC = () => {
    const { path, url } = useRouteMatch();
    const { pathname } = useLocation();
    const isCollectionNavigationV2Enabled = useFeature(COLLECTION_NAVIGATION_V2);

    return (
        <Switch>
            <Route exact path={`${path}`}>
                <Redirect to={`${url}/reserves`} />
            </Route>
            <Route exact path={`${path}/reserves`}>
                {isCollectionNavigationV2Enabled ? (
                    <Redirect to={pathname.replace('/assistant', '/collectionmgmt')} />
                ) : (
                    <ReserveReportList />
                )}
            </Route>
            <Route exact path={`${path}/reserve/:reserveListId`}>
                {isCollectionNavigationV2Enabled ? (
                    <Redirect to={pathname.replace('/assistant/reserve', '/collectionmgmt/reserves')} />
                ) : (
                    <ReserveDetail />
                )}
            </Route>
            <Route exact path={`${path}/reserve/:reserveListId/checkout`}>
                {isCollectionNavigationV2Enabled ? (
                    <Redirect to={pathname.replace('/assistant/reserve', '/collectionmgmt/reserves')} />
                ) : (
                    <ReserveCheckout />
                )}
            </Route>
            <Route exact path={`${path}/subscriptions`}>
                {isCollectionNavigationV2Enabled ? (
                    <Redirect to={pathname.replace('/assistant', '/collectionmgmt')} />
                ) : (
                    <ManageSubscriptionsPage />
                )}
            </Route>
            <Route exact path={`${path}/subscriptions/renewals`}>
                {isCollectionNavigationV2Enabled ? (
                    <Redirect to={pathname.replace('/assistant', '/collectionmgmt')} />
                ) : (
                    <ManageRenewalsPage />
                )}
            </Route>
            <Route>
                <PageNotFound />
            </Route>
        </Switch>
    );
};
